import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

@Injectable({
  providedIn: 'root',
})

export class VideoStorageService {
  private dbPromise: Promise<IDBPDatabase>;

  constructor() {
    this.dbPromise = this.initDB();
  }

  private async initDB() {
    return await openDB('video-store', 1, {
      upgrade(db) {
        db.createObjectStore('videos');
      },
    });
  }

  async storeVideo(key: string, blob: Blob) {
    const db = await this.dbPromise;
    await db.put('videos', blob, key);
  }

  async getVideo(key: string): Promise<Blob | undefined> {
    const db = await this.dbPromise;
    return await db.get('videos', key);
  }

  async deleteVideo(key: string) {
    const db = await this.dbPromise;
    await db.delete('videos', key);
  }

  async clearAllVideos() {
    const db = await this.dbPromise;
    await db.clear('videos');
  }

  async getAllKeys(): Promise<IDBValidKey[]> {
    const db = await this.dbPromise;
    return await db.getAllKeys('videos');
  }
}
